const INITIAL_STATE = {
  all: [],
  current: null,
}

export default {
  namespaced: true,
  state: {
    ...INITIAL_STATE
  },
  getters: {
    find: (state) => (id) => state.find(el => el.id === id),
  },
  mutations: {
    setCurrent: (state, { item }) => {
      state.current = item
    },
    add: (state, { item, prepend = false }) => {
      if (prepend) {
        state.all.unshift(item)
      } else {
        state.all.push(item)
      }
    },
    remove: (state, { id }) => {
      let idx = state.all.findIndex(el => el.id === id)
      state.all.splice(idx, 1)
    },
    
  },
  actions: {
    acceptTerms: ({ dispatch, rootGetters, commit }) => {
      let headers = {
        'Content-Type': 'application/json',
      }
      Object.assign(headers, rootGetters['Api/getAuthHeader'])
      
      return dispatch('Api/apiRequest', {
        actionPath: '/api/users/acceptTerms.json',
        method: 'post',
        headers: headers,
        
      }, { root: true }).then(result => {
        
        commit('addClient', result)
        
        return Promise.resolve(result)
      })
    },
    changePassword: (
      { dispatch, getters, commit, rootGetters }, { password }) => {
      let headers = {
        'Content-Type': 'application/json',
      }
      Object.assign(headers, rootGetters['Api/getAuthHeader'])
      
      return dispatch('Api/apiRequest', {
        actionPath: '/api/users/changePassword.json',
        method: 'post',
        headers: headers,
        data: { password },
      }, { root: true }).then(result => {
        
        commit('addClient', result)
        
        return Promise.resolve(result)
      })
    },
    forgotPassword: (
      { dispatch, getters, commit, rootGetters }, { email, identifier }) => {
      let headers = {
        'Content-Type': 'application/json',
      }
      Object.assign(headers, rootGetters['Api/getAuthHeader'])
      
      return dispatch('Api/apiRequest', {
        actionPath: '/api/users/forgotPassword.json',
        method: 'post',
        headers: headers,
        data: { email, identifier },
      }, { root: true }).then(result => {
        
        commit('addClient', result)
        
        return Promise.resolve(result)
      })
    },
    info: ({ dispatch, getters, commit, rootGetters }) => {
      let headers = {
        // 'Content-Type': 'application/json',
      }
      Object.assign(headers, rootGetters['Api/getAuthHeader'])
      
      return dispatch('Api/apiRequest', {
        actionPath: '/api/users/info.json',
        method: 'get',
        headers: headers,
        
      }, { root: true }).then(result => {
        
        commit('setCurrent', { item: result })
        
        return Promise.resolve(result)
      })
    },
    login: ({ dispatch, getters, commit, rootGetters }, { token }) => {
      let headers = {
        'Content-Type': 'application/json',
      }
      Object.assign(headers, rootGetters['Api/getAuthHeader'])
      
      return dispatch('Api/apiRequest', {
        actionPath: '/api/users/login.json',
        method: 'post',
        headers: headers,
        data: { token },
      }, { root: true }).then(result => {
        
        commit('setCurrent', { item: result })
        
        return Promise.resolve(result)
      })
    },
    logout: ({ dispatch, getters, commit, rootGetters }) => {
      let headers = {
        'Content-Type': 'application/json',
      }
      Object.assign(headers, rootGetters['Api/getAuthHeader'])
      
      return dispatch('Api/apiRequest', {
        actionPath: '/api/users/logout.json',
        method: 'POST',
        headers: headers,
      }, { root: true })
        .then(result => {
          commit('setCurrent', { item: null })
          
          return Promise.resolve(result)
        })
    },
    request_access: ({ dispatch, getters, commit, rootGetters }, data) => {
      let headers = {
        'Content-Type': 'application/json',
      }
      Object.assign(headers, rootGetters['Api/getAuthHeader'])
      
      return dispatch('Api/apiRequest', {
        actionPath: '/api/users/request_access.json',
        method: 'post',
        headers: headers,
        data: data,
      }, { root: true }).then(result => {
        
        commit('addClient', result)
        
        return Promise.resolve(result)
      })
    },
    support: ({ dispatch, getters, commit, rootGetters }) => {
      let headers = {
        'Content-Type': 'application/json',
      }
      Object.assign(headers, rootGetters['Api/getAuthHeader'])
      
      return dispatch('Api/apiRequest', {
        actionPath: '/api/users/support.json',
        method: 'post',
        headers: headers,
        
      }, { root: true }).then(result => {
        
        commit('addClient', result)
        
        return Promise.resolve(result)
      })
    },
    deleteAccount: ({ dispatch, getters, commit, rootGetters }) => {
      let headers = {
        'Content-Type': 'application/json',
      }
      Object.assign(headers, rootGetters['Api/getAuthHeader'])
      
      return dispatch('Api/apiRequest', {
        actionPath: '/api/users/delete-account.json',
        method: 'post',
        headers: headers,
        
      }, { root: true }).then(result => {
        return Promise.resolve(result)
      })
    },
  },
}
